var Backbone= require("backbone");
var DashboardDetailsModel = require("models/dashboard.model.ts");
require("backbonePaginator");
require("compat");

var PaginatedCollection = Backbone.PageableCollection.extend({
	mode: "server",
	model: DashboardDetailsModel,
	// Initial pagination states
	state:
	{
		pageSize: 4,
		sortKey: "id",
		order: 1,
		firstPage: 0,
		page: 0
	},
	// Be sure to change this based on how your results are structured
	parse : function ( response )
	{
		if(!response.data && !response.content)
		{
			return response;
		}

		var data = response.data;
		if (data.dashboardVenues && data.dashboardVenues.collection ) {
            data.collection = data.dashboardVenues.collection;
            data.totalCount = data.dashboardVenues.totalCount;
            data.pagesCount = data.dashboardVenues.pagesCount;

            this.totalPages = data.dashboardVenues.pagesCount;
            data.dashboardVenues = data.dashboardVenues.collection;

        } else if (data.dashboardQueues && data.dashboardQueues.collection ) {
            data.collection = data.dashboardQueues.collection;
            data.totalCount = data.dashboardQueues.totalCount;
            data.pagesCount = data.dashboardQueues.pagesCount;

            this.totalPages = data.dashboardQueues.pagesCount;
            data.dashboardQueues = data.dashboardQueues.collection;
        }
        if (data.dashboardVenue && !data.dashboardVenues) {
            data.dashboardVenues = [];
            data.dashboardVenues.push(data.dashboardVenue);
        }

		this.state.lastPage = this.totalPages - 1;

		return data;
	},
	// Used by the template
	info : function ()
	{
		var info =
		{
			firstPage : this.state.firstPage,
			page : this.state.currentPage,
			lastPage : this.state.lastPage,
			perPage : this.state.pageSize
		};
		this.information = info;
		return info;
	}
});
module.exports = PaginatedCollection;